import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "../../Constants/baseStyles"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    bottomTabBar: { height: 70, paddingBottom: 15, position: "absolute" },
    label: {
        fontSize: 12,
        fontFamily: baseFontFamily.OpenSansSemiBold
    }
})

export default styles
